import React, { useState, useEffect } from 'react';
import './blogs-page.css';
import 'react-multi-carousel/lib/styles.css';
import moment from 'jalali-moment'
// svgs
import { TabPanel, TabView } from 'primereact/tabview';
import { Col } from 'react-bootstrap';
import SecondaryBanner from '../banner/secondary-banner';
import { getBlogsAndNewsBySearch, imgBaseUrl } from '../../utils/api';
import Calendar from '../../assets/icons/calendar.svg';
import Time from '../../assets/icons/time.svg';
import Loader from '../../components/loader/dotloader'

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const requestPayload = {
        pageSize: 0,
        pageIndex: 0,
      };
      const res = await getBlogsAndNewsBySearch(requestPayload);
      if (res.data.isSuccess) {
        setProducts(res.data.data.items || []); // Handle potential empty data
        setLoading(false)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);
  const jalaliDate = (date) => {
    console.log(date)
    let persianDate = moment(date, 'YYYY-MM-DDTHH:mm:ss')
      .locale('fa') // Set locale to Persian
      .format('DD MMMM YYYY');
    return persianDate
  }
  const renderHtml = (rowData) => {
    const textContent = rowData.replace(/<[^>]+>/g, ''); // حذف تگ‌های HTML
    return (
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '500px',
          marginLeft: 'auto',
          marginRight: 'auto'

        }}
        title={textContent} // نمایش متن کامل در tooltip
      >
        {textContent}
      </div>
    );
  };

  return (
    <div>
      {loading && <Loader isLoading={loading} />}

      <div>
        <SecondaryBanner slug='blogs1' />
      </div>
      <section className="position-relative">
        <div className="tab-home mt-5 container">
          <div className="d-flex align-items-center gap-3 justify-content-between flex-mob-col flex-align">
            <h1 className="text-3xl font-bold leading-10" style={{ borderBottom: '2px solid #00A14B' }}>
              اخبار طبیعی باش و بلاگ ها
            </h1>
            <div className="flex gap-2 justify-content-center tab-btn">
              <button onClick={() => setActiveIndex(0)} className={activeIndex !== 0 ? 'btn' : 'btn tab-active'}>
                همه
              </button>
              <button onClick={() => setActiveIndex(1)} className={activeIndex !== 1 ? 'btn ml-3' : 'btn tab-active ml-3'}>
                اخبار طبیعی باش
              </button>
              <button onClick={() => setActiveIndex(2)} className={activeIndex !== 2 ? 'btn' : 'btn tab-active'}>
                بلاگ
              </button>
            </div>
          </div>

          <div className="row">
            <Col md={12} sm={12}>
              <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="All">
                  <div className="row flex-wrap">
                    {products.filter((product) => product.isActive == true)
                      .map((product) => (
                        <>
                          <Col md={3} sm={3} className=" mt-2 web-blog" key={product.id}>
                            <div className="blogs-item" onClick={() => { window.location.href = `/blog?id=${product.id}` }}>
                              <img src={imgBaseUrl + product.logoPath} className="mx-auto img-box img-product" alt="Blog Image" />
                              <h5 className='mt-3 font-bold'>{product.summery}</h5>
                              <div className="d-flex align-items-center gap-3 mt-3">
                                <div className="d-flex align-items-center gap-3">
                                  <img src={Calendar} alt="Calendar icon" />
                                  <h6 >{jalaliDate(product.createDate)}</h6>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                  <img src={Time} alt="Time icon" />
                                  <h6>{product.readTime} دقیقه زمان مطالعه</h6>
                                </div>
                              </div>

                              <h6 className='mt-3 body-blog'>{renderHtml(product.body)}</h6>                            </div>
                          </Col>
                          <Col md={12} sm={12} className="p-2 mt-2 mobile-blog" key={product.id}>
                            <div
                              className="blogs-item"
                              onClick={() => { window.location.href = `/blog?id=${product.id}` }}
                              style={{
                                backgroundImage: `url('${imgBaseUrl + product.logoPath}')`,
                                backgroundSize: 'cover', // Ensures the image covers the container
                                backgroundPosition: 'center', // Centers the image
                                backgroundRepeat: 'no-repeat', // Prevents tiling
                              }}
                            >
                              <div className='body-blog1 detail'>
                                <h4 className=' mt-2 font-bold'>{product.summery}</h4>                                  <div className="d-flex align-items-start gap-3 flex-col">
                                  <div className="d-flex align-items-center gap-3 mt-3">
                                    <img src={Calendar} alt="Calendar icon" />
                                    <h6>{jalaliDate(product.createDate)} </h6>
                                  </div>
                                  <div className="d-flex align-items-center gap-3">
                                    <img src={Time} alt="Time icon" />
                                    <h6>{product.readTime} دقیقه زمان مطالعه</h6>
                                  </div>
                                </div>
                                <div>

                                  <h6 className='mt-2 body-blog'>{renderHtml(product.body)}</h6>
                                </div>
                              </div>

                            </div>
                          </Col>
                        </>


                      ))}
                  </div>
                </TabPanel>

                <TabPanel header="اخبار طبیعی باش">
                  <div className="row">
                    {products
                      .filter((product) => product.typeId == 1 && product.isActive == true)
                      .map((product) => (
                        <div className='row'>
                        <Col md={3} sm={3} className=" mt-2 web-blog" key={product.id}>
                            <div className="blogs-item" onClick={() => { window.location.href = `/blog?id=${product.id}` }}>
                              <img src={imgBaseUrl + product.logoPath} className="mx-auto img-box img-product" alt="Blog Image" />
                              <h5 className='mt-3 font-bold'>{product.summery}</h5>
                              <div className="d-flex align-items-center gap-3 mt-3">
                                <div className="d-flex align-items-center gap-3">
                                  <img src={Calendar} alt="Calendar icon" />
                                  <h6 >{jalaliDate(product.createDate)}</h6>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                  <img src={Time} alt="Time icon" />
                                  <h6>{product.readTime} دقیقه زمان مطالعه</h6>
                                </div>
                              </div>

                              <h6 className='mt-3 body-blog'>{renderHtml(product.body)}</h6>                            </div>
                          </Col>
                          <Col md={12} sm={12} className="p-2 mt-2 mobile-blog" key={product.id}>
                            <div
                              className="blogs-item"
                              onClick={() => { window.location.href = `/blog?id=${product.id}` }}
                              style={{
                                backgroundImage: `url('${imgBaseUrl + product.logoPath}')`,
                                backgroundSize: 'cover', // Ensures the image covers the container
                                backgroundPosition: 'center', // Centers the image
                                backgroundRepeat: 'no-repeat', // Prevents tiling
                              }}
                            >
                              <div className='body-blog1 detail'>
                                <h4 className=' mt-2 font-bold'>{product.summery}</h4>                                  <div className="d-flex align-items-start gap-3 flex-col">
                                  <div className="d-flex align-items-center gap-3 mt-3">
                                    <img src={Calendar} alt="Calendar icon" />
                                    <h6>{jalaliDate(product.createDate)} </h6>
                                  </div>
                                  <div className="d-flex align-items-center gap-3">
                                    <img src={Time} alt="Time icon" />
                                    <h6>{product.readTime} دقیقه زمان مطالعه</h6>
                                  </div>
                                </div>
                                <div>

                                  <h6 className='mt-2 body-blog'>{renderHtml(product.body)}</h6>
                                </div>
                              </div>

                            </div>
                          </Col>
                        </div>
                      ))}
                  </div>
                </TabPanel>

                <TabPanel header="بلاگ">
                  <div className="row">
                    {products
                      .filter((product) => product.typeId == 2 && product.isActive == true)
                      .map((product) => (
                        <div className='row'>
                     <Col md={3} sm={3} className=" mt-2 web-blog" key={product.id}>
                            <div className="blogs-item" onClick={() => { window.location.href = `/blog?id=${product.id}` }}>
                              <img src={imgBaseUrl + product.logoPath} className="mx-auto img-box img-product" alt="Blog Image" />
                              <h5 className='mt-3 font-bold'>{product.summery}</h5>
                              <div className="d-flex align-items-center gap-3 mt-3">
                                <div className="d-flex align-items-center gap-3">
                                  <img src={Calendar} alt="Calendar icon" />
                                  <h6 >{jalaliDate(product.createDate)}</h6>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                  <img src={Time} alt="Time icon" />
                                  <h6>{product.readTime} دقیقه زمان مطالعه</h6>
                                </div>
                              </div>

                              <h6 className='mt-3 body-blog'>{renderHtml(product.body)}</h6>                            </div>
                          </Col>
                          <Col md={12} sm={12} className="p-2 mt-2 mobile-blog" key={product.id}>
                            <div
                              className="blogs-item"
                              onClick={() => { window.location.href = `/blog?id=${product.id}` }}
                              style={{
                                backgroundImage: `url('${imgBaseUrl + product.logoPath}')`,
                                backgroundSize: 'cover', // Ensures the image covers the container
                                backgroundPosition: 'center', // Centers the image
                                backgroundRepeat: 'no-repeat', // Prevents tiling
                              }}
                            >
                              <div className='body-blog1 detail'>
                                <h4 className=' mt-2 font-bold'>{product.summery}</h4>                                  <div className="d-flex align-items-start gap-3 flex-col">
                                  <div className="d-flex align-items-center gap-3 mt-3">
                                    <img src={Calendar} alt="Calendar icon" />
                                    <h6>{jalaliDate(product.createDate)} </h6>
                                  </div>
                                  <div className="d-flex align-items-center gap-3">
                                    <img src={Time} alt="Time icon" />
                                    <h6>{product.readTime} دقیقه زمان مطالعه</h6>
                                  </div>
                                </div>
                                <div>

                                  <h6 className='mt-2 body-blog'>{renderHtml(product.body)}</h6>
                                </div>
                              </div>

                            </div>
                          </Col>
                        </div>
                      ))}
                  </div>
                </TabPanel>
              </TabView>
            </Col>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
